import { CandidateRegistrationDtoClient } from "@/api/candidate/dto/candidate-registration.dto";
import { Badge } from "@/components/atoms/Badge";
import { PayementUtil } from "@/lib/payement-util";

interface RegisteringStatusBadgeProps {
  registration: CandidateRegistrationDtoClient;
}

const RegistrationStatusBadge = ({
  registration,
}: RegisteringStatusBadgeProps) =>
  PayementUtil.isPaid(registration.payementStatus) ? (
    <Badge variant="green">Inscrit</Badge>
  ) : (
    <Badge variant="orange">Pré-inscrit</Badge>
  );

export default RegistrationStatusBadge;
